import { polarClient } from "@polar-sh/better-auth";
import {
	magicLinkClient,
	oneTimeTokenClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { env } from "./env";

export const authClient = createAuthClient({
	baseURL: env.VITE_SERVER_URL,
	plugins: [polarClient(), magicLinkClient(), oneTimeTokenClient()],
});

export interface SessionUser {
	email: string;
	id: string;
	image?: string | null;
	name?: string | null;
}

const SESSION_TTL_MS = 30_000;
let cached: { at: number; user: SessionUser | null } | null = null;
let inflight: Promise<SessionUser | null> | null = null;

/**
 * Route guards run on every navigation; cache the session briefly so we don't
 * hit /api/auth/get-session for each click. Call `invalidateSession` after
 * sign-in / sign-out.
 */
export function getSessionUser(): Promise<SessionUser | null> {
	if (cached && Date.now() - cached.at < SESSION_TTL_MS) {
		return Promise.resolve(cached.user);
	}
	if (inflight) {
		return inflight;
	}
	inflight = authClient
		.getSession()
		.then(({ data }) => {
			const user = data?.user ? (data.user as SessionUser) : null;
			cached = { at: Date.now(), user };
			return user;
		})
		.catch(() => {
			cached = { at: Date.now(), user: null };
			return null;
		})
		.finally(() => {
			inflight = null;
		});
	return inflight;
}

export function invalidateSession(): void {
	cached = null;
}
